{
  "it": {
    "baseChip": {
      "states": {
        "included": "incluso",
        "excluded": "escluso"
      }
    }
  }
}
